import createImageUrlBuilder from "@sanity/image-url";
import { Image } from "@sanity/types";

import { dataset, projectId } from "./api";
import { ImageFromSanity } from "../components/types";

const imageBuilder = createImageUrlBuilder({
	projectId: projectId || "",
	dataset: dataset || "",
});

export const urlForImage = (source: ImageFromSanity | undefined) => {
	// Ensure that source image contains a valid reference
	if (!source?.asset?._ref) {
		return undefined;
	}

	// Cast to Sanity Image type for the image builder
	const sanityImage = source as Image;

	return imageBuilder?.image(sanityImage).quality(80).auto("format").fit("max");
};
